import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { bootTheme, consumeTokenFromUrl } from '@jackdesk/shell'
import { sweepDrafts } from '@jackdesk/erp-kit'
import '@jackdesk/shell/shell.css'
import { App } from './App'

// Before React mounts, so the first paint is not the wrong colour.
bootTheme()
// A token handed over by another Jackdesk app arrives in the address bar. It
// is taken once and stripped here, before anything can bookmark it, keep it in
// history or pass it on in a Referer header — which is what makes the hand-off
// from the store or HR silent rather than a second sign-in.
consumeTokenFromUrl()
// Drop abandoned half-forms older than a day.
sweepDrafts()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
